import { string } from "prop-types";

export class UserLoginSubmit {
  contact: string | null | undefined;
  login_type: string | null | undefined;
}
